import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  type = 'button',
  variant = 'primary',
  ariaLabel,
  outline = false,
  ghost = false,
  size = 'md',
  block = false,
  disabled = false,
  loading = false,
  className = '',
  onClick,
  children,
  ref,
  uniqueID,
  value,
  notification = '',
  'data-cy': dataCy,
  style,
}) => {
  let colorClass = 'btn-';
  if (outline) {
    colorClass += 'outline-';
  } else if (ghost) {
    colorClass += 'ghost-';
  }
  colorClass += variant;

  let badge = '';
  if (notification) badge = ' position-relative';

  const buttonContent = (
    <button
      type={type}
      className={`btn btn-${size} ${colorClass} ${className}${badge}`}
      disabled={loading || disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      ref={ref}
      key={uniqueID}
      value={value}
      data-cy={dataCy}
      style={style ? style : {}}
    >
      {loading
        ? <span><span className='fas fa-spinner fa-spin me-2' />Loading...</span>
        : children
      }
      {notification &&
        <span className={`position-absolute top-0 start-100 translate-middle bg-danger ${typeof notification === 'string' && notification.length >= 0 ? 'badge rounded-pill' : 'p-2 rounded-circle'}`}>
          {typeof notification === 'string' && notification.length > 0 ? notification : null}
        </span>
      }
    </button>
  );

  return block
    ? <div className='d-grid'>{buttonContent}</div>
    : buttonContent;
};

Button.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  ariaLabel: PropTypes.string,
  outline: PropTypes.bool,
  ghost: PropTypes.bool,
  size: PropTypes.string,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
  notification: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  ref: PropTypes.any,
  uniqueID: PropTypes.string,
  value: PropTypes.any,
  'data-cy': PropTypes.string,
  style: PropTypes.object,
};

export default Button;
